<template>
  <RegisterContainer>
    <div>
      <header class="form-header mb-4">
        <h2 class="title-text">Is this your first time using HereRx for {{ visitType }}?</h2>
      </header>

      <div class="d-flex flex-column" style="gap: 16px">
        <TruformeOption @click="setNewReturning(true)" :selected="isNew">
          <template #title> First time </template>
        </TruformeOption>
        <!-- @click="setNewReturning(false)" -->
        <TruformeOption :selected="!isNew" disabled>
          <template #title>
            Returning patient <v-chip label small color="success">Coming soon!</v-chip>
          </template>
        </TruformeOption>
      </div>
    </div>
  </RegisterContainer>
</template>
<style lang="scss" scoped>
.form-header {
  padding: 0px !important;
}

@media all and (max-width: 768px) {
  .form-header {
    .title-text {
      font-size: 1.3rem !important;
    }
  }
}
</style>
<script lang="ts">
import RegisterContainer from '../components/RegisterContainer.vue';
import TruformeOption from '../components/Truforme/TruformeOption.vue';

export default {
  name: 'TruformeNewReturning',
  components: {
    RegisterContainer,
    TruformeOption,
  },
  computed: {
    completed() {
      return true;
    },
    reason() {
      return this.$store.state.registration.reasonForVisit;
    },
    isNew() {
      return !this.$store.state.registration.isReturningPatient;
    },
    visitType() {
      if (this.reason === 'glp') return 'weight loss';
      return 'erectile dysfunction';
    },
  },
  methods: {
    onNextClick() {},
    setNewReturning(isNew) {
      this.$store.commit('setRegistration', { isReturningPatient: !isNew });
    },
  },
  mounted() {
    this.$store.commit('setOnNextClick', () => {
      if (this.isPageflowV2) {
        this.$emit('next');
      } else {
        this.$router.push({ name: this.$store.getters.nextFlowRoute(this.$route.name) });
      }
    });
  },
};
</script>
